if(!customElements.get('product-card')) {
  customElements.define(
    'product-card',
    class ProductCard extends HTMLElement {
      productDataEl = null;
      productData = null;
      addToCartButtons = null;

      constructor() {
        super();
      }

      connectedCallback() {
        this.productDataEl = this.querySelector('[type="application/json"]');
        this.addToCartButtons = this.querySelectorAll('[data-add-to-cart]:not([disabled])');
        this.init();
      }

      init() {
        if(!this.productDataEl) return console.error('Unable to initialize product card. Product data is missing.');

        this.productData = JSON.parse(this.productDataEl.textContent);

        this.handleAddToCart();
      }

      handleAddToCart() {
        if(!this.addToCartButtons?.length > 0) return;
        
        this.addToCartButtons.forEach(button => {
          button.addEventListener('click', async () => {
            button.classList.add('loading');

            const firstAvailableVariant = this.productData.variants.find(variant => variant.available);

            const formData = {
              items: [{
                id: firstAvailableVariant.id,
                quantity: 1
              }]
            }

            try {
              const response = await fetch('/cart/add.js', {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify(formData)
              });

              if(!response.ok) {
                return console.error('Unexpected error while trying to add product to cart.');
              }

              const data = await response.json();

              Toast.notify({
                message: `${data.items[0].product_title} was added to cart`,
                type: "success"
              });
            } catch(err) {
              console.error(err);
              Toast.notify({
                message: "Something went wrong, please try again.",
                type: "error"
              });
            } finally {
              button.classList.remove('loading');
            }
          });
        });
        
      }
    }
  );
}